// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".disclosure,.disclosure_button-wrapper{max-width:none}.disclosure_button{width:auto;padding:0;border:none;background:transparent;color:inherit;font:inherit;line-height:normal;width:100%;max-width:none;cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
